// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// 饿了么
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//导入时间戳处理函数
import { formatDate } from "./common/date";
//导入按钮防抖
import { noMultipleClicks } from "./common/no-multiple-clicks";
import { isEmptyObj } from "./common/common.js";
// 防止快速点击重复调用接口
import preventReClick from "@/assets/js/preventReClick";
Vue.use(preventReClick);
// 公共样式
import "./assets/css/style.scss";
// 轮播图
// import 'swiper/dist/css/swiper.css';
// 字体图标
import "./assets/iconfonts/iconfont.css";
//md5加密
import md5 from "js-md5";
//复制
import VueClipBoard from "vue-clipboard2";
// vue滑块验证
import SlideVerify from "vue-monoplasty-slide-verify";
import Vuex from "vuex";
import store from "./store";
import RelationGraph from 'relation-graph' 
import * as echarts from 'echarts';
import 'echarts-liquidfill'
// import { WebGPURenderer } from 'three/examples/jsm/renderers/WebGPURenderer.js';
// swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// import ForceGraph3D from '3d-force-graph';
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

Vue.config.productionTip = false;
Vue.prototype.$TimeData = formatDate;
Vue.prototype.$noMultipleClicks = noMultipleClicks;
Vue.prototype.$isEmptyObj = isEmptyObj;
Vue.prototype.$previewPath = process.env.VUE_APP_API_BASE_URL + '/preview/'
Vue.use(RelationGraph) 
// Vue.use(ForceGraph3D);
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(VueClipBoard);
Vue.prototype.$md5 = md5;
/* eslint-disable no-new */

// 使用vue滑块验证
Vue.use(SlideVerify);
// import VueSocketIO from 'vue-socket.io'
// import SocketIO from 'socket.io-client'

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: SocketIO('ws://127.0.0.1:24000')
// }));
/** init domain config */
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
Vue.prototype.API_SOCKET_URL = process.env.VUE_APP_API_SOCKET_URL;

window._CONFIG._URL = {};
window._CONFIG._URL.BaseUrl = Vue.prototype.API_BASE_URL;
window._CONFIG._URL.socketUrl = process.env.VUE_APP_API_SOCKET_URL;

router.beforeEach((to, from, next) => {
  // 路由跳转后，让页面回到顶部
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  if (localStorage.getItem("token") != null) {
    if (store.state.userInfo.userIdentity == 2) {
      if (
        to.path.slice(0, 14) == "/teacher/index" ||
        to.path.slice(0, 19) == "/teacher/myTeaching" ||
        to.path.slice(0, 21) == "/teacher/schoolManage" ||
        to.path.slice(0, 32) == "/teacher/schoolBasicCourseManage"
      ) {
        router.push({ path: "/" });
        // next(); //放行路由
      } else {
        // next(); //放行路由
      }
    }
  } else {
    if (
      to.path.slice(0, 14) == "/teacher/index" ||
      to.path.slice(0, 19) == "/teacher/myTeaching" ||
      to.path.slice(0, 21) == "/teacher/schoolManage" ||
      to.path.slice(0, 32) == "/teacher/schoolBasicCourseManage" ||
      to.path.slice(0, 23) == "/teacher/courseLearning" ||
      to.path.slice(0, 23) == "/teacher/personalCenter" ||
      to.path.slice(0, 16) == "/teacher/myStudy"
    ) {
      router.push(`/login/${0}`);
      // next(); //放行路由
    }
  }
  next(); //放行路由
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  store
});
